/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Message from '../Common/Message/Message';
import './OnboardComplete.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class OnboardComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: {
                title: '',
                content: '',
                type: ''
            },
            code: '',    
            token: '',
        };
    }

    componentDidMount = () => {
        this.getParams();
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    getParams = async () => {
        this.setMessage('', '', 'loading');
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const token = urlParams.get('state');
        if (code && token) {
            this.setState({
                code,
                token,
            });
            try {
                const urlResponse = await postURL(code, token);
                console.log('urlResponse: ', urlResponse);
                if (urlResponse.data.success) {
                    this.setMessage(window.general_strings.msg.yay, 'Account successfully linked. You will be redirected to your account in a few seconds.', 'success');
                    setTimeout(() => {
                        if (this.props.user.role) {
                            this.props.routeProps.history.push('/client/billing');
                        } else {
                            this.props.routeProps.history.push('/login');
                        }
                    }, 2000);
                } else {
                    if (urlResponse.data.error.code === 'client-has-existing-stripe-account') {
                        this.setMessage(window.general_strings.msg.oops, 'Account already linked. You will be redirected to your account in a few seconds.', 'error');
                        setTimeout(() => {
                            if (this.props.user.role) {
                                this.props.routeProps.history.push('/client/billing');
                            } else {
                                this.props.routeProps.history.push('/login');
                            }
                        }, 2000);
                    } else {
                        this.setMessage(window.general_strings.msg.oops, urlResponse.data.error.message + '. Please try again or contact support.', 'error');
                    }
                }
                
                
            } catch (error) {
                console.log(error);
            }
        } else {
            this.setMessage('', '', '');
        }

		async function postURL(code, token) {
			return await ApiRequest(`/stripe/onboarding`, {
                method: 'POST',
                data: {
                    code,
                    token,
                }
            });
        }
    }

    
    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
               
            </React.Fragment>
        );
    }
}

OnboardComplete.propTypes = {
}

export default OnboardComplete;



// WEBPACK FOOTER //
// ./src/components/OnboardComplete/OnboardComplete.js